// request.js
import axios from 'axios'
import Vue from 'vue'
import store from "../../store";
const instance = axios.create({
  baseURL: 'http://gkb.gaozhaotong.cn/',
  timeout: 10000
})

axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
// 实例拦截器
instance.interceptors.request.use(config => {
  // console.log(this.$store.state.token);
  let token = ""
  if (window.location.href.indexOf("localhost") > -1) {
    token = store.state.myToken
  } else {

    token = lycamWeb.getCookie("token");
  }
  // const token = '2de4wWwo2pGA'
  // 配置文件    头
  config.headers = config.headers || {}
  // 携带请求头
  config.headers['token'] = token;
  return config
}, err => Promise.reject(err))
instance.interceptors.response.use(res => {
    if (res.data.code !== 0) {
      // 统一的网络请求报错处理
      // Vue.use(Element) 就在 Vue的prototype上面添加element相关的API
      Vue.prototype.$message.error(res.data.msg)
    }
    return res.data
  },
  function (error) {
    // axios.defaults.baseURL = lycamWeb.getHost();
    // tryHideFullScreenLoading();
    setTimeout(() => {
      store.commit("skeState", false);
    }, 100);
    // console.log(reqNum);
    if (error.response) {

      console.log(error.response);
      let status = error.response.status;
      if (status == 403) {
        if (lycamWeb.is_weixn_qq() == "weixin") {
          console.log(13212132);
          // 用户授权
          lycamWeb.delCookie("token");
          console.log("token", lycamWeb.getCookie("token"));


          Vue.prototype.$setErrorNum(store.state.errorNum + 1);
          // alert(store.state.errorNum)
          if (store.state.errorNum == 1) {
            var reg = new RegExp("\\?from\\=groupmessage");
            var cc = window.location.href.replace(reg, "");
            var reUrl = encodeURIComponent(cc);
            var reUrl = encodeURIComponent(window.location.href);
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              lycamWeb.getAppid() +
              "&redirect_uri=" +
              reUrl +
              "&response_type=code&scope=snsapi_userinfo&state=315318";
          }
        } else if (lycamWeb.is_weixn_qq() == "QQ" && !lycamWeb.IsPC()) {
          lycamWeb.delCookie("token");
          var reg = new RegExp("\\?from\\=groupmessage");
          var cc = window.location.href.replace(reg, "");
          var reUrl = encodeURIComponent(cc);
          // var reUrl = encodeURIComponent(window.location.href);
          window.location.href =
            "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=1105569906&redirect_uri=" +
            reUrl +
            "&state=315318&scope=get_user_info";
        } else {
          if (reqNum == 0) {
            lycamWeb.delCookie("token");
            Vue.prototype.$loginphone();
          }
        }
        return;
      } else {
        console.log("服务器连接失败！" + error.message);
      }
    }
    // 超时处理
    var config = error.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(error);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(error);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function () {
      return axios(config);
    });

    // return Promise.reject(error);
  })
export default instance



// WEBPACK FOOTER //
// ./src/assets/request/request.js